import { Chip } from './Chip';
import { EloDelta } from './EloDelta';

export interface PlayerRowProps {
  rank: number;
  name: string;
  elo: number;
  delta: number;
  group?: string;
  className?: string;
}

export function PlayerRow({ rank, name, elo, delta, group, className }: PlayerRowProps) {
  const initial = name.slice(0, 1).toUpperCase();
  return (
    <tr className={['border-t border-border', className].filter(Boolean).join(' ')}>
      <td className="px-4 py-3 font-mono text-foreground-muted w-10 tabular-nums">{rank}</td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2.5">
          <span className="w-7 h-7 rounded-full bg-muted inline-flex items-center justify-center text-xs text-foreground-soft">
            {initial}
          </span>
          <span className="font-medium">{name}</span>
          {group && (
            <Chip tone="outline" className="!px-2 !py-px text-[10px]">гр.{group}</Chip>
          )}
        </div>
      </td>
      <td className="px-4 py-3 font-mono tabular-nums text-right">{elo}</td>
      <td className="px-4 py-3 text-right w-16">
        <EloDelta delta={delta} />
      </td>
    </tr>
  );
}
